<template>
  <div class="container">
    <NavigationBar />
    <LoaderErrorBlock
      v-if="!isLoaded"
      class="row no-space justify-center"
      :error-title="hasLoadingError ? $gettext('Oops! We couldn’t load this right now.') : ''"
      :error-message="hasLoadingError ? $gettext('Please refresh the page or try again later.') : ''"
    />

    <template v-else>
      <ImpersonateNotification v-if="isImpersonateMode" />
      <router-view />
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import ImpersonateNotification from '@/components/CommonUI/ImpersonateNotification.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import NavigationBar from '@/components/NavigationBar.vue'
import { useAdvanceStore } from '@/store'

const store = useStore()
const { getAdvanceHistory } = useAdvanceStore()

const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'

const isLoaded = ref(false)
const hasLoadingError = ref(false)

const isImpersonateMode = computed(() => store.getters.isImpersonateMode)

onMounted(async () => {
  try {
    await store.dispatch('getJwtUser')
  } catch {
    window.location.replace(`${dashboardUrl}/login`)
    return
  }

  try {
    await Promise.all([
      store.dispatch('getUserSubscription').catch(() => undefined),
      store.dispatch('getUserVerification'),
      store.dispatch('getUserProfile'),
      getAdvanceHistory(1),
    ])

    await store.dispatch('getUserCurrencyConversionRate')

    if (store.getters.isSubscriptionMissing) {
      await store.dispatch('getUserActiveReleases')
    }

    isLoaded.value = true
  } catch {
    hasLoadingError.value = true
  }
})
</script>

<style lang="scss">
main {
  padding-top: var(--navTopPos);

  @media (--max-small) {
    padding-top: 0;
  }
}
.panel.error .icon {
  margin-left: 1rem;
  vertical-align: bottom;
}
</style>
